import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 }
};

export default function FAQ() {
  const { t } = useTranslation();

  const faqs = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
    { q: t('faq.q6'), a: t('faq.a6') },
    { q: 'How long does shipping take?', a: 'Standard shipping takes 5-10 business days worldwide. Express shipping options are available at checkout.' },
    { q: 'Can I order multiple cards?', a: 'Yes! You can order as many cards as you need. Enterprise plans offer bulk pricing for teams.' },
    { q: 'What happens when I tap the card?', a: 'When someone taps their phone on your card, their browser automatically opens to your digital profile. No app download required.' },
    { q: 'Can I use the card with a phone case?', a: 'Yes, the contactless technology works through most phone cases. Very thick or metal cases may reduce range slightly.' },
  ];

  return (
    <div className="min-h-screen pt-24 pb-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div {...fadeUp} className="text-center mb-16">
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-4">
            {t('faq.title')}
          </h1>
          <p className="text-lg text-slate-600">
            {t('faq.subtitle')}
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div {...fadeUp}>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, idx) => (
              <AccordionItem 
                key={idx} 
                value={`item-${idx}`}
                className="bg-slate-50 rounded-2xl px-6 border-none"
                data-testid={`faq-${idx}`}
              >
                <AccordionTrigger className="text-left font-medium text-slate-900 hover:no-underline py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        {/* Still have questions */}
        <motion.div {...fadeUp} className="mt-16 text-center bg-slate-50 rounded-3xl p-8">
          <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">
            Still have questions?
          </h2>
          <p className="text-slate-600 mb-6">
            Can't find the answer you're looking for? Our support team is here to help.
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center justify-center btn-primary"
            data-testid="contact-support-btn"
          >
            Contact Support
          </a>
        </motion.div>
      </div>
    </div>
  );
}
